module.exports = __webpack_public_path__ + "static/img/laravel.d5055a16.png";